import React from 'react';
import TestCards from './Components/TestCards/TestCards';
import ExpertsBadge from './Components/ExpertsBadge/ExpertsBadge';
import TestLanguage from './Components/TestLanguage/TestLanguage';

function TestsPanel(): React.JSX.Element {
    return (
        <div className="flex flex-col items-center gap-4">
            <div className="flex flex-col items-center gap-4">
                <TestLanguage />
                <TestCards />
            </div>
            <ExpertsBadge />
        </div>
    );
}

export default TestsPanel;
